import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import { LanguageProvider, useLang } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import PostRequest from "@/pages/PostRequest";
import Feed from "@/pages/Feed";
import Pricing from "@/pages/Pricing";
import Dashboard from "@/pages/Dashboard";
import ClientSpace from "@/pages/ClientSpace";
import ProDirectory from "@/pages/ProDirectory";
import ProProfile from "@/pages/ProProfile";
import EditProfile from "@/pages/EditProfile";
import { PaymentSuccess, PaymentCancel, AuthCallback } from "@/pages/Payment";
import { Radar } from "lucide-react";

function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t border-border bg-card mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <div className="grid place-items-center h-8 w-8 rounded-lg bg-primary text-primary-foreground">
            <Radar className="h-4 w-4" />
          </div>
          <span className="font-display font-bold">{t("brand")}</span>
        </div>
        <div className="flex items-center gap-6 text-sm text-muted-foreground">
          <Link to="/feed" className="hover:text-primary">{t("nav_feed")}</Link>
          <Link to="/pricing" className="hover:text-primary">{t("nav_pricing")}</Link>
          <Link to="/post" className="hover:text-primary">{t("nav_post")}</Link>
        </div>
        <p className="text-xs text-muted-foreground">© 2026 {t("brand")}. {t("footer_rights")}</p>
      </div>
    </footer>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-1 flex flex-col">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/post" element={<PostRequest />} />
          <Route path="/feed" element={<Feed />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/my-requests" element={<ClientSpace />} />
          <Route path="/pros" element={<ProDirectory />} />
          <Route path="/pros/:userId" element={<ProProfile />} />
          <Route path="/profile/edit" element={<EditProfile />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
